import { eventBus } from '@/util'

// webview/app页面关闭通知h5页面
const onAppear = function (callback) {
  eventBus.addListener('WEBVIEWONAPPEAR', data => {
    callback && callback(data)
  })
}

export default onAppear